<div class="dialogContent calcHeight content">
  <irb-settings-dialog-banner
    [accordian]="accordion"
    [showUnsavedChangesWarning]="showUnsavedChangesWarning"
    [isModified]="isModified"
    [validationErrorTemplates]="validationErrorTemplates"
    [showExpandControls]="true"
  (save)="save()">Automated Rebalancing</irb-settings-dialog-banner>
  <div class="body" >
    <mat-accordion #accordion="matAccordion" [multi]="true">
      @if (globalSettings) {
        <mat-expansion-panel [expanded]="false" (opened)="iss.updateExpansionState('HISTORY','opened')" (closed)="iss.updateExpansionState('HISTORY','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Settings History
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <irb-settings-history tabName="AutomatedRebalancing"></irb-settings-history>
          </ng-template>
        </mat-expansion-panel>
      }
      @if (globalSettings) {
        <mat-expansion-panel [expanded]="iss.getDefaultExpansionState('AUTOMATION_SETTINGS')" (opened)="iss.updateExpansionState('AUTOMATION_SETTINGS','opened')" (closed)="iss.updateExpansionState('AUTOMATION_SETTINGS','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Automation Settings
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="block">This allows automated rebalancing and trading for selected portfolios. You can configure individual portfolios on the Portfolio page.</div>
            <div><strong>Automated Rebalancing</strong></div>
            <div class="dblock bottomBorder" style="{{(!isAdmin || !isAutomation) ? 'pointer-events:none;' : ''}}">
              <p-radioButton inputId="setatitem1" [disabled]="!isAdmin || !isAutomation" name="isTAutomationEnabled" [value]="true" [(ngModel)]="globalSettings.isAutoRebalanceEnabled" (ngModelChange)="onAutoRebalanceEnabledChange()"></p-radioButton>
              <label for="setatitem1" [class.p-disabled]="!isAdmin || !isAutomation">Enabled</label>
              <p-radioButton inputId="setatitem2" [disabled]="!isAdmin || !isAutomation" name="isTAutomationEnabled" [value]="false" [(ngModel)]="globalSettings.isAutoRebalanceEnabled" (ngModelChange)="onAutoRebalanceEnabledChange()"></p-radioButton>
              <label for="setatitem2" [class.p-disabled]="!isAdmin || !isAutomation">Disabled</label>
            </div>
            <div class="dblock">
              <div class="block">
                <div class="block"><strong>User and Account Settings</strong></div>
              </div>
              <div class="block">
                <div>User ID</div>
                <irb-dropdown-filter #automatedUserID
                  [disabled]="!isAdmin || !isAutomation || !globalSettings.isAutoRebalanceEnabled"
                  [(value)]="automatedUserIDSetting"
                  (search)="setAutomatedUserIDSetting($event)"
                  size="30" hoverPanelWidth="280"
                  placeholder="Select the User ID"
                (valueChange)="onAutomatedUserIDChange()"></irb-dropdown-filter>
                <div class="hint">
                  Select a user ID with access to accounts targeted for automated rebalancing.
                </div>
              </div>
              <div class="dblock bottomBorder">
                <div>Master Account Number</div>
                <irb-dropdown-filter #automatedMasterAccount
                  [disabled]="!isAdmin || !isAutomation || !globalSettings.isAutoRebalanceEnabled"
                  [(value)]="automatedMasterAccountSetting"
                  (search)="setAutomatedMasterAccountSetting($event)"
                  size="30" hoverPanelWidth="280"
                  placeholder="Select the Master Account Number"
                (valueChange)="onAutomatedMasterAccountChange()"></irb-dropdown-filter>
                <div class="hint">
                  Select a master account to submit block orders.
                </div>
              </div>
            </div>
            <div class="dblock">
              <div class="block"><strong>Order Settings</strong></div>
              <div class="dblock">
                <div>Order time (EST)</div>
                <div class="block">
                  <irb-dropdown-filter #automatedTradingTime
                    [disabled]="!isAdmin || !isAutomation || !globalSettings.isAutoRebalanceEnabled"
                    [(value)]="automatedTradingTimeSetting"
                    (search)="setAutomatedTradingTimeSetting($event)"
                    size="30" hoverPanelWidth="280"
                  (valueChange)="onAutomatedTradingTimeChange()"></irb-dropdown-filter>
                </div>
                <div class="hint">
                  Starting at this time, automated rebalances will be validated and submitted from the order blotter.
                </div>
              </div>
              <div>Automated Rebalance Orders</div>
              <div class="hint">
                Pending orders on the blotter will be canceled when paused before the selected order time.<br/>
                Rebalancing paused after the selected order time will take effect on the following market day.
              </div>
              <div class="block" style="{{(getIsTradingPausedDisabled()) ? 'pointer-events:none;' : ''}}">
                <p-radioButton inputId="setatitem7" [disabled]="getIsTradingPausedDisabled()" name="isTradingPaused" [value]="false" [(ngModel)]="isTradingPaused" (ngModelChange)="onTradingPausedChange()"></p-radioButton>
                <label for="setatitem7" [class.p-disabled]="getIsTradingPausedDisabled()">Active</label>&nbsp;
                <p-radioButton inputId="setatitem8" [disabled]="getIsTradingPausedDisabled()" name="isTradingPaused" [value]="true" [(ngModel)]="isTradingPaused" (ngModelChange)="onTradingPausedChange()"></p-radioButton>
                <label for="setatitem8" [class.p-disabled]="getIsTradingPausedDisabled()">Paused</label>
              </div>
              @if (isAdmin && isAutomation && isTradingPaused) {
                <div class="block  status-message warning">
                  <p>
                    <span class="main">
                      Automated rebalancing is paused and will not complete for all portfolios.
                    </span>
                  </p>
                </div>
              }
            </div>
          </ng-template>
        </mat-expansion-panel>
      }
      @if (globalSettings) {
        <mat-expansion-panel [expanded]="iss.getDefaultExpansionState('MMC_AUTOMATION')" (opened)="iss.updateExpansionState('MMC_AUTOMATION','opened')" (closed)="iss.updateExpansionState('MMC_AUTOMATION','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Model Market Center
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="block">Configure automated rebalancing for portfolios assigned to Model Market Center models.</div>
            <div class="block"><irb-expando-link text="How does automated rebalancing work with Model Market Center models?">
              <p>Any Model Market Center models, including those used in blended models, may be subject to changes by the model provider that can affect your portfolio allocations and trades.</p>
              <p>Automated rebalancing can be configured in individual model settings.</p>
              <p><strong>Allow:&nbsp;</strong>This allows you to use Model Market Center models, including those used in blended models, for automated rebalancing. Allowing automated rebalancing at this level will not override individual Model Market Center model’s settings.</p>
              <p><strong>Do not allow:&nbsp;</strong>No Model Market Center models can be used for automated rebalancing while “Do not allow” is selected. This setting will override existing settings for individual Model Market Center models.</p>
              <ul style="list-style-type: disc; margin: -15px 0 0 -15px;">
                <li>When automated rebalancing is not allowed, any portfolios assigned to a Model Market Center model, including those used in blended models, can only be manually rebalanced.</li>
              </ul>
            </irb-expando-link></div>
            <div class="mmc-auto-rebalance-section-header"><strong>Automated Rebalancing</strong></div>
            <div class="mmc-auto-rebalance-description">This allows portfolios assigned to a Model Market Center model, including those used in blended models, to be automatically rebalanced.</div>
            <div class="block" style="{{(!isAdmin || !isAutomation || !globalSettings.isAutoRebalanceEnabled) ? 'pointer-events:none;' : ''}}">
              <p-radioButton inputId="setatitem3" [disabled]="!isAdmin || !isAutomation || !globalSettings.isAutoRebalanceEnabled" name="allowMMCPortApproval" [value]="true" [(ngModel)]="allowMMCPortApproval" (ngModelChange)="onMMCPortApprovalEnabled()"></p-radioButton>
              <label for="setatitem3"     [class.p-disabled]="!isAdmin || !isAutomation || !globalSettings.isAutoRebalanceEnabled">Allow</label>
              <p-radioButton inputId="setatitem4" [disabled]="!isAdmin || !isAutomation || !globalSettings.isAutoRebalanceEnabled" name="allowMMCPortApproval" [value]="false" [(ngModel)]="allowMMCPortApproval" (ngModelChange)="onMMCPortApprovalDisabled()"></p-radioButton>
              <label for="setatitem4" [class.p-disabled]="!isAdmin || !isAutomation || !globalSettings.isAutoRebalanceEnabled">Do not allow</label>
            </div>
            @if (MMCAutomationEnabled) {
              <div class="mmc-auto-rebalance-section-header"><strong>Review changes</strong></div>
              <div class="mmc-auto-rebalance-description">When a model is changed by the model provider, would you like to pause automated rebalancing to allow for review?</div>
              <div class="block" style="{{(!isAdmin || !isAutomation || !globalSettings.isAutoRebalanceEnabled || !allowMMCPortApproval) ? 'pointer-events:none;' : ''}}">
                <p-radioButton inputId="setatitem5" [disabled]="!isAdmin || !isAutomation || !globalSettings.isAutoRebalanceEnabled || !allowMMCPortApproval" name="allowAutoRebalOnMMCUpdate" [value]="false" [(ngModel)]="allowAutoRebalOnMMCUpdate" (ngModelChange)="onAllowAutoRebalOnMMCUpdateChange()"></p-radioButton>
                <label for="setatitem5" [class.p-disabled]="!isAdmin || !isAutomation || !globalSettings.isAutoRebalanceEnabled || !allowMMCPortApproval">Pause for review</label> &nbsp;
                <p-radioButton inputId="setatitem6" [disabled]="!isAdmin || !isAutomation || !globalSettings.isAutoRebalanceEnabled || !allowMMCPortApproval" name="allowAutoRebalOnMMCUpdate" [value]="true" [(ngModel)]="allowAutoRebalOnMMCUpdate" (ngModelChange)="onAllowAutoRebalOnMMCUpdateChange()"></p-radioButton>
                <label for="setatitem6" [class.p-disabled]="!isAdmin || !isAutomation || !globalSettings.isAutoRebalanceEnabled || !allowMMCPortApproval">Continue without review</label>
              </div>
              @if (isAdmin && isAutomation && globalSettings.isAutoRebalanceEnabled && allowMMCPortApproval) {
                @if (allowAutoRebalOnMMCUpdate) {
                  <div class="block  status-message warning">
                    <p>
                      <span class="main">
                        Continuing without review means that if a Model Market Center provider makes changes to a model (including those used in blended models), those changes will be implemented in the next automated rebalance. This could result in unplanned trades or fees.  Note: You will still be notified of any changes made to your subscribed models.
                      </span>
                    </p>
                  </div>
                }
                @if (!allowAutoRebalOnMMCUpdate) {
                  <div class="block  status-message warning">
                    <p>
                      <span class="main">
                        Pausing for review means that if a Model Market Center provider makes changes to a model, all automated rebalances will be paused for that model until you go to the model’s settings to review and resume automated rebalancing.
                      </span>
                    </p>
                  </div>
                }
              }
            }
            @if (isAdmin && isAutomation && globalSettings.isAutoRebalanceEnabled) {
              @if (!allowMMCPortApproval) {
                <div class="block  status-message info">
                  <p>
                    <span class="main">
                      Automated rebalancing will not complete for portfolios assigned to Model Market Center models (including those used in blended models).
                    </span>
                  </p>
                </div>
              }
            }
            @if (isAdmin && isAutomation && globalSettings.isAutoRebalanceEnabled && !MMCAutomationEnabled) {
              @if (allowMMCPortApproval) {
                <div class="block  status-message warning">
                  <p>
                    <span class="main">
                      Any changes to Model Market Center models will be implemented in your next scheduled automated rebalance.
                    </span>
                  </p>
                </div>
              }
            }
          </ng-template>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
</div>
